import Competition from 'app/components/tv/models/competition';
import RoundResource from 'app/components/tv/apiResources/RoundResource';
import {generateMatchDayTitle} from 'app/helpers/actionsHelpers';

export default class Round {
  id: number;
  type: string;
  slug: string;
  competitionSeason: Competition;
  number: number;

  constructor(data: RoundResource) {
    this.id = data.id;
    this.type = data.type;
    this.slug = data.slug;
    this.competitionSeason = new Competition(data.competitionSeason);
    this.number = data.number;
  }

  format(): string {
    return generateMatchDayTitle(this);
  }
}
